import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import { OrgAlertListPayload, OrgAlertListRespose } from './org-alert-list.types';

export async function listOrgAlertService({ query: rawQuery }: OrgAlertListPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.get<OrgAlertListRespose>(ENDPOINT.ALERT_GROUP_ACTIONS, { query });

  return {
    response,
    summary: data,
  };
}
